import * as pdfjsLib from 'pdfjs-dist';

// Configure the worker source
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

export async function extractTextFromPDF(file: File): Promise<string> {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const loadingTask = pdfjsLib.getDocument({
      data: arrayBuffer,
      useWorkerFetch: true,
      isEvalSupported: true,
      useSystemFonts: true
    });

    const pdf = await loadingTask.promise;
    const textChunks: string[] = [];
    
    for (let i = 1; i <= pdf.numPages; i++) {
      try {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent({
          normalizeWhitespace: true,
          disableCombineTextItems: false
        });
        
        const pageText = textContent.items
          .filter((item: any) => item.str && typeof item.str === 'string')
          .map((item: any) => item.str)
          .join(' ');
        
        textChunks.push(pageText);
      } catch (pageError) {
        console.warn(`Warning: Error on page ${i}, continuing with next page`, pageError);
      }
    }
    
    const fullText = textChunks.join('\n')
      .replace(/\s+/g, ' ')
      .replace(/[^\x20-\x7E]/g, ' ')
      .trim();
    
    return fullText || 'No text content could be extracted from the PDF';
  } catch (error) {
    console.error('PDF extraction error:', error);
    return 'Error: Could not process PDF file. Please try uploading a different file format (DOCX or TXT).';
  }
}